/* bb-soft-nav-refresh.js

   Colour swatches on the PDP do a SOFT navigation: `color-metafield .product_btn`
   swaps the buy box and pushes a new product URL, without a page load. Only the
   main product section is re-rendered — every other section on the page keeps the
   PREVIOUS product's server-rendered Liquid.

   That is why Better Together kept showing Mist Lavender's companion after
   switching to Regal Plum: its metafield was read at render time for the old
   product and never re-read.

   The size rails solve this themselves (they rebuild from a client-side index).
   Liquid-rendered sections cannot, so this refetches them.

   Deliberately narrow: only sections listed in TARGETS are refreshed, and only on
   an actual product-URL change. If the fetch fails, the stale-but-valid section is
   left alone rather than blanked.
*/
(function () {
  'use strict';

  // Section key suffixes to refresh. Two spellings exist: the 14 pre-existing
  // instances use `better-together`, the 52 I added use `better_together`.
  var TARGETS = ['__better-together', '__better_together'];

  var current = location.pathname;
  var inFlight = false;

  function sectionsOnPage() {
    return [].slice.call(document.querySelectorAll('[id^="shopify-section-"]'))
      .filter(function (el) {
        return TARGETS.some(function (t) { return el.id.indexOf(t) !== -1; });
      });
  }

  function refresh(pathname) {
    if (inFlight) return;
    var targets = sectionsOnPage();
    if (!targets.length) return;
    inFlight = true;

    fetch(pathname, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('fetch ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        targets.forEach(function (el) {
          // Match on the key suffix, not the whole id — the template id prefix
          // changes when the swatch lands on a product using another template.
          var key = TARGETS.filter(function (t) { return el.id.indexOf(t) !== -1; })[0];
          var fresh = doc.querySelector('[id$="' + key + '"]');
          if (!fresh) {
            // The new product genuinely has no companion — clear rather than lie.
            el.innerHTML = '';
            return;
          }
          el.innerHTML = fresh.innerHTML;
        });
        // Let the theme re-bind anything inside what we just replaced.
        document.dispatchEvent(new CustomEvent('bb:section-reloaded'));
      })
      .catch(function () { /* keep what is on screen */ })
      .then(function () { inFlight = false; });
  }

  function check() {
    if (location.pathname === current) return;
    if (location.pathname.indexOf('/products/') === -1) { current = location.pathname; return; }
    current = location.pathname;
    refresh(current);
  }

  // The swatch does not emit an event we control, so watch for the DOM churn it
  // causes and re-check the URL. Debounced, and a no-op unless the path changed.
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(check, 150); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  function start() {
    if (!sectionsOnPage().length) return;      // not a PDP with a refreshable section
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('popstate', schedule);
  }
})();
